import { Logger } from 'sierra-client/core/logging/logger'

export const scormConnectionStatus = Logger.trackLogger<{
  success: boolean
}>('scorm_connection_status', false)
